import { createContext } from "react";

const interestContext = createContext();

export default interestContext;
